"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolygonSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const LineStyle_1 = require("./LineStyle");
const XYPosition_1 = require("./XYPosition");
exports.PolygonSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('polygon'),
    filled: zod_1.z.coerce.boolean().optional(),
    width: zod_1.z.number(),
    pos: XYPosition_1.XYPositionSchema.optional(),
    angle: zod_1.z.number().optional(),
    points: XYPosition_1.XYPositionSchema.array(),
    lineStyle: LineStyle_1.LineStyleSchema.optional(),
});
//# sourceMappingURL=Polygon.js.map